import { render } from "./Grupo.vue?vue&type=template&id=9a6778ae&scoped=true"
import script from "./Grupo.vue?vue&type=script&lang=js"
export * from "./Grupo.vue?vue&type=script&lang=js"

import "./Grupo.vue?vue&type=style&index=0&id=9a6778ae&scoped=true&lang=css"

import exportComponent from "/var/www/html/facturacion/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a6778ae"]])

export default __exports__